import React from 'react';
import PropTypes from 'prop-types';

import { shiftColorShade, determineFontColor } from 'lib/colorLogic';
import getRadius from 'lib/getRadius';
import overrideStyle from 'lib/overrideStyle';
import DataRequestStatusBanner from 'presentation/selfService/DataRequestStatusBanner.jsx';

const COLOR_SHIFT_AMOUNT = 4;

export default function PaymentRequestMessageItem(props) {
  return (
    <PaymentRequestMessage>
      <AmountText aria-live="polite">{props.amount}</AmountText>
      <MemoFlexWrapper>
        <MemoText aria-live="polite">{props.memo}</MemoText>
      </MemoFlexWrapper>
      {/*  TODO add logic to switch between button and banner */}
      <DataRequestStatusBanner />
      <ButtonWrapper>
        {/* TODO add onDecline method */}
        <DeclineButton tabIndex="0">
          <ButtonText>Decline</ButtonText>
        </DeclineButton>
        <PayButton onClick={props.onInitiateSecurePayment} tabIndex="0">
          <ButtonText>Enter Payment</ButtonText>
        </PayButton>
      </ButtonWrapper>
    </PaymentRequestMessage>
  );
}

PaymentRequestMessageItem.propTypes = {
  amount: PropTypes.number.isRequired,
  memo: PropTypes.string.isRequired,
  onInitiateSecurePayment: PropTypes.func.isRequired,
};

const AmountText = overrideStyle('div')`
  font-size: 24px;
  font-weight: 500;
  height: 24px;
  text-align: center;
  padding: 0px 0px 10px 0px;
  width: 100%;
`;

const Button = overrideStyle('div')`
  display: flex;
  border-radius: ${p => getRadius(p.theme.borderRadius, 8, 16)};
  cursor: pointer;
  justify-content: center;
  flex-direction: column;
  height: 30px;
  margin: 0px 10px;
  transition: 0.2s ease;
  width: 120px;
`;

const DeclineButton = overrideStyle(Button)`
  border:1px solid #E4E4E4;
  &:focus{
    border: 1px solid #a3a3a3;
  }
  &:active{
    border: 1px solid #a3a3a3;
  }
  &:hover{
    border: 1px solid #a3a3a3;
    background-color: #eeeeee;
  }
`;

const PayButton = overrideStyle(Button)`
  background-color: ${p => p.theme.colors.brandPrimary};
  border: 1px solid ${p => p.theme.colors.brandPrimary};
  color: ${p => determineFontColor(p.theme.colors.brandPrimary)};
  &:focus{
    background-color: ${p => shiftColorShade(p.theme.colors.brandPrimary, COLOR_SHIFT_AMOUNT)};
    border: 1px solid${p => shiftColorShade(p.theme.colors.brandPrimary, COLOR_SHIFT_AMOUNT)};
  }
  &:active{
    background-color: ${p => shiftColorShade(p.theme.colors.brandPrimary, -COLOR_SHIFT_AMOUNT)};
    border:1px solid ${p => shiftColorShade(p.theme.colors.brandPrimary, COLOR_SHIFT_AMOUNT)};
  }
  &:hover{
    background-color: ${p => shiftColorShade(p.theme.colors.brandPrimary, COLOR_SHIFT_AMOUNT)};
    border:1px solid ${p => shiftColorShade(p.theme.colors.brandPrimary, COLOR_SHIFT_AMOUNT)};
  }
`;

const ButtonText = overrideStyle('div')`
  cursor: pointer;
  font-family: ${p => p.theme.fontLibrary.primary};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
`;

const ButtonWrapper = overrideStyle('div')`
  display: flex; 
  flex-direction: row;
  justify-content: center;
  margin-top: 10px;
  width: 100%;
`;

const MemoFlexWrapper = overrideStyle('div')`
  display: flex;
  justify-content: center;
`;

const MemoText = overrideStyle('div')`
  color: #929292;
  font-size: 12px;
  height: 30px;
  text-align: center;
  width: 174px;
`;

const Message = overrideStyle('div')`
  border-radius: ${p => getRadius(p.theme.borderRadius, 8, 16)};
  border: 1px solid #E4E4E4;
  flex: 0 0 auto;
  font-family: ${p => p.theme.fontLibrary.primary};
  padding: 10px 15px;
`;

const PaymentRequestMessage = overrideStyle(Message)`  
  display: flex; 
  flex-direction: column;
  height: 150px;
  justify-content: center;
  padding: 12px 0px;
  margin: 14px;
  align-self: center;
  width 330px;
`;
